import { FC, ReactNode } from 'react';
import {
  useFloating,
  useInteractions,
  useHover,
  offset,
  flip,
  shift,
  Placement,
  autoUpdate,
  FloatingPortal
} from '@floating-ui/react';
import './Tooltip.css';

interface TooltipProps {
  content?: ReactNode;
  placement?: Placement;
  className?: string;
}

const Tooltip: FC<TooltipProps> = ({ 
  content,
  placement = 'top',
  className = ''
}) => {
  const { refs, floatingStyles, context } = useFloating({
    placement,
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(8),
      flip(),
      shift()
    ]
  });

  const hover = useHover(context, {
    delay: { open: 200, close: 100 }
  });
  
  const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

  if (!content) return null;

  return (
    <>
      <span 
        ref={refs.setReference} 
        {...getReferenceProps()}
        className="tooltip-trigger"
      >
        ⓘ
      </span>
      <FloatingPortal>
        {context.open && (
          <div
            ref={refs.setFloating}
            style={floatingStyles}
            className={`tooltip-content ${className}`}
            {...getFloatingProps()}
          >
            {content}
          </div>
        )}
      </FloatingPortal>
    </>
  );
};

export default Tooltip;
